import { Col, Row } from 'antd'
import { Card, Icon, LoadingSpinner, Modal, ButtonGroup, Toggle, Tooltip, Switcher } from 'pepsico-ds'
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import ModalFilters from './ModalFilters';
import InfoIcon from '../Icons/InfoIcon';
import { formatNumberWithCommas, splitValueWithUnit, returnHyphenIfNull, splitNumericValue, handleDomToImgDownloadPdf } from '../../utils/utils'
import { localStoreKeys } from '../../constants/localStoreKeys';
import Legend from '../Charts/Legend/Legend'
import LegendList from '../Charts/Legend/LegendList'
import NoData from '../NoData/NoData';
import CommonTable from '../Table/CommonTable';
import { saveAs } from 'file-saver';
import { urlConstants } from '../../constants/urlConstants';
import Vector from '../../assets/Vector.png'
import SCMLineBarChart from '../Charts/SCMChart/SCMLineBarChart';
import SCMWaterfallChart from '../Charts/SCMChart/SCMWaterfallChart';
import SpendDonutChart from '../Charts/SpendAnalyticsChart/SpendDonutChart'
import CustomButtons from '../Cards/CustomButtons';
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";
import DropdownWithIcons from './DropdownWithIcons';
import { useToast } from '../../components/Toast/ToastContext';
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';
// import WorldMap from '../WorldMap/WorldMap'


const cellDataFunction = (ctx) => {
    const colId = ctx.column.id
    const percentage = ctx.row.original[colId]
    return (
        <div style={{ textAlign: 'center', paddingLeft: 15 }}>{percentage}</div>
    )
}


const cellDataPercentFunction = (ctx) => {
    const colId = ctx.column.id
    const percentage = ctx.row.original[colId] || 0
    return (
        <div>{percentage}%</div>
    )
}
const columns = [
  { columnKey: "a", header: "" },
  {
    columnKey: "category",
    header: "Category L2",
    columnAlignment: "center",
    size: 500,
    minSize: 500,
    cellData: cellDataFunction,
    maxSize: 500
  },
  {
    columnKey: "sectorBU",
    header: "Sector-BU",
    size: 100,
    minSize: 100,
    maxSize: 100,
    columnAlignment: "center",
  },
  {
    columnKey: "newSKUs",
    size: 100,
    minSize: 100,
    maxSize: 100,
    header: "# Unique SKUs Modeled",
    columnAlignment: "center",
    
  },
  {
    columnKey: "volume",
    columnAlignment: "center",
    size: 100,
    minSize: 100,
    maxSize: 100,
    header: "Volume of SKUs",
  },
  {
    columnAlignment: "center",
    size: 100,
    minSize: 100,
    maxSize: 100,
    columnKey: "purchaseCost",
    header: "Purchase Cost / unit vol. ($)",
  },
  {
    columnKey: "gapValue",
    header: "Gap ∆ / unit vol. ($)",
    columnAlignment: "center",
    cellData: ctx => {
      // const purchaseCost = ctx.row.original.purchaseCost || 0
      // const shouldCost = ctx.row.original.shouldCost || 0
      const tdClassName =
        ctx.row.original.gapValue > 0 ? "scm-td-red" : "scm-td-green";
      return (
        <div className={tdClassName}>{ctx.row.original.gapValue || 0}</div>
      );
    },
    size: 100,
    minSize: 100,
    maxSize: 100
  },
  {
    columnKey: "gapPercent",
    header: "Gap ∆ / unit vol. (%)",
    columnAlignment: "center",
    cellData: ctx => {
      // const purchaseCost = ctx.row.original.purchaseCost || 0
      // const shouldCost = ctx.row.original.shouldCost || 0
      const tdClassName =
        ctx.row.original.gapValue > 0 ? "scm-td-red" : "scm-td-green";
      return (
        <div className={tdClassName}>{ctx.row.original.gapPercent || 0}%</div>
      );
    },
    size: 100,
    minSize: 100,
    maxSize: 100
  },
  {
    columnKey: "shouldCost",
    header: "Should Cost / unit vol. ($)",
    columnAlignment: "center",
    size: 100,
    minSize: 100,
    maxSize: 100
  },
  {
    columnKey: "materialCost",
    header: "Material Cost %",
    columnAlignment: "center",
    size: 100,
    minSize: 100,
    maxSize: 100
  },
  {
    columnKey: "conversionCost",
    size: 100,
    minSize: 100,
    maxSize: 100,
    header: "Conversion Cost %",
    columnAlignment: "center",
    
  },
  {
    
    size: 100,
    minSize: 100,
    maxSize: 100,
    columnKey: "overheadAndIndirectCost",
    header: "Overhead And Indirects Cost %",
    columnAlignment: "center",
  },
  {
    columnKey: "profitPercent",
    header: "Profit %",
    minSize: 100,
    maxSize: 100,
    columnAlignment: "center",
    size: 100,
    
  },
  {
    
    size: 100,
    minSize: 100,
    maxSize: 100,
    columnKey: "logisticsCost",
    header: "Logistics Cost %",
    columnAlignment: "center",
  }
];


function SCMModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters }) {
    const [scmData, setScmData] = useState({})
    const [loader, setLoader] = useState(true)
    const [toggleValue, setToggleValue] = useState(true)
    const [barChartToggleValue, setBarChartToggleValue] = useState(false)
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    const [dataLoadActionType, setDataLoadActionType] = useState("");
    
    // console.log("toggleValue", toggleValue)
    const MODAL_TITLE = 'Should Cost Modelling';

    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);

    const handleClose = () => {
        try {          
            trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        // Clear data load action type
        setDataLoadActionType("");
        // Close the modal
        setOpenModal(false);
    };
    
    const getSCMDataFromFilters = (value) => {
        
        let appList = [];
        if(value?.data?.type==="SUCCESS_SCM_DETAIL_VIEW_ACTION") {
            
            setScmData(value.data)   
            setLoader(value.loader);
            setDataLoadActionType(value?.data?.type)
            appList = value.data?.apps
        }
        setCatChartSwitcherIndex(0)
        setBuChartSwitcherIndex(0)
        if (value.modalName == "Should Cost Modelling" && appList && appList.length > 0) {
            const tempbuttonGroupItems =[
              //  { icon: "ondemand_video", label: "", onClick: () => window.open(urlConstants.archletVideo, "_blank") },
                ...appList
                .filter(item => item.isActive)
                .map(item => ({
                    label: item.app,
                    onClick: () => window.open(item.url, "_blank"),
                }))];

            setButtonGroupItems(tempbuttonGroupItems)
        }
    }
    const waterfallChartData = scmData?.barChartDetails
    const isAllDataZero = waterfallChartData?.valueData?.every(item => item.uv === 0 && item.pv === 0);
    // let linebarchartData = []
    const linebarchartsavingsOpportunityMonthWiseSkuCountData = scmData?.monthWiseSkuCountDetails?.savingsOpportunityMonthWiseSkuCountDetails
    const linebarchartNetSavingsMonthWiseSkuCountData = scmData?.monthWiseSkuCountDetails?.netSavingsMonthWiseSkuCountDetails
    
    const uniqueSkusModeledSavingsOpportunityCount = linebarchartsavingsOpportunityMonthWiseSkuCountData?.reduce((sum, item) => sum + item.newSKUs, 0).toString();
    const uniqueSkusModeledNetSavingsCount = linebarchartNetSavingsMonthWiseSkuCountData?.reduce((sum, item) => sum + item.newSKUs, 0).toString();


    const scmTableData = scmData?.categoryBUWiseDetails

    // console.log("scmData", scmData)
    // const savingsOpportunityIdentified = scmData?.savingsOpportunitysavingsOpportunityHeaderDetails?.opportunities;
    const savingsOpportunityIdentified = scmData?.savingsOpportunityHeaderDetails?.opportunities;
    const benchMarkedSavingsVsShouldCost = scmData?.benchMarkSavingsHeaderDetails?.opportunities;
    const netSavingsTotalOpportunity = scmData?.netSavingsHeaderDetails?.opportunities;
    // const headerColorFlag = scmData?.savingsOpportunityHeaderDetails?.flag;
    // const savingsOpportunityIdentified = "$30.1BN";
    const savingsOpportunityIdentifiedValue = splitValueWithUnit(savingsOpportunityIdentified)?.['numericValue']
    const savingsOpportunityIdentifiedUnit = splitValueWithUnit(savingsOpportunityIdentified)?.['unit']

    const benchMarkedSavingsVsShouldCostValue = splitValueWithUnit(benchMarkedSavingsVsShouldCost)?.['numericValue']
    const benchMarkedSavingsVsShouldCostUnit = splitValueWithUnit(benchMarkedSavingsVsShouldCost)?.['unit']

    const NetSavingsTotalOpportunityValue = splitValueWithUnit(netSavingsTotalOpportunity)?.['numericValue']
    const NetSavingsTotalOpportunityUnit = splitValueWithUnit(netSavingsTotalOpportunity)?.['unit']
    // const newSKUsModeled = '456'
    // const newSKUsModeled = scmData?.savingsOpportunityHeaderDetails?.skusModeled
    const newSKUsModeledSavingsOpportunityIdentified = scmData?.savingsOpportunityHeaderDetails?.skusModeled
    const newSKUsModeledBenchMarkedSavingsVsShouldCost = scmData?.benchMarkSavingsHeaderDetails?.skusModeled
    const newSKUsModeledNetSavingsTotalOpportunity = scmData?.netSavingsHeaderDetails?.skusModeled
    // const totalPurchaseCost = scmData?.savingsOpportunityHeaderDetails?.totalPurchaseCost
    const totalPurchaseCostSavingsOpportunityIdentified = scmData?.savingsOpportunityHeaderDetails?.totalPurchaseCost
    const totalPurchaseCostBenchMarkedSavingsVsShouldCost = scmData?.benchMarkSavingsHeaderDetails?.totalPurchaseCost
    const totalPurchaseCostNetSavingsTotalOpportunity = scmData?.netSavingsHeaderDetails?.totalPurchaseCost
    // const totalPurchaseCost = "$120.5MN";
    const totalPurchaseCostValueSavingsOpportunityIdentified = splitValueWithUnit(totalPurchaseCostSavingsOpportunityIdentified)?.['numericValue']
    const totalPurchaseCostUnitSavingsOpportunityIdentified = splitValueWithUnit(totalPurchaseCostSavingsOpportunityIdentified)?.['unit']

    const totalPurchaseCostBenchMarkedSavingsVsShouldCostValue = splitValueWithUnit(totalPurchaseCostBenchMarkedSavingsVsShouldCost)?.['numericValue']
    const totalPurchaseCostBenchMarkedSavingsVsShouldCostUnit = splitValueWithUnit(totalPurchaseCostBenchMarkedSavingsVsShouldCost)?.['unit']

    const totalPurchaseCostNetSavingsTotalOpportunityValue = splitValueWithUnit(totalPurchaseCostNetSavingsTotalOpportunity)?.['numericValue']
    const totalPurchaseCostNetSavingsTotalOpportunityUnit = splitValueWithUnit(totalPurchaseCostNetSavingsTotalOpportunity)?.['unit']
    // const totalShouldCost = scmData?.savingsOpportunityHeaderDetails?.totalShouldCost
    const totalShouldCostSavingsOpportunityIdentified = scmData?.savingsOpportunityHeaderDetails?.totalShouldCost
    const totalShouldCostBenchMarkedSavingsVsShouldCost = scmData?.benchMarkSavingsHeaderDetails?.totalShouldCost
    const totalShouldCostNetSavingsTotalOpportunity = scmData?.netSavingsHeaderDetails?.totalShouldCost
    // const totalShouldCost = "$109.12MN";
    const totalShouldCostSavingsOpportunityIdentifiedValue = splitValueWithUnit(totalShouldCostSavingsOpportunityIdentified)?.['numericValue']
    const totalShouldCostSavingsOpportunityIdentifiedUnit = splitValueWithUnit(totalShouldCostSavingsOpportunityIdentified)?.['unit']

    const totalShouldCostBenchMarkedSavingsVsShouldCostValue = splitValueWithUnit(totalShouldCostBenchMarkedSavingsVsShouldCost)?.['numericValue']
    const totalShouldCostBenchMarkedSavingsVsShouldCostUnit = splitValueWithUnit(totalShouldCostBenchMarkedSavingsVsShouldCost)?.['unit']

    const totalShouldCostNetSavingsTotalOpportunityValue = splitValueWithUnit(totalShouldCostNetSavingsTotalOpportunity)?.['numericValue']
    const totalShouldCostNetSavingsTotalOpportunityUnit = splitValueWithUnit(totalShouldCostNetSavingsTotalOpportunity)?.['unit']
    
    const isEDFIntegrated = scmData?.edfintegrated;
    
    // const volumeOfSKUs = '999'
    const volumeOfSKUssavingsOpportunityIdentified = scmData?.savingsOpportunityHeaderDetails?.totalVolume
    const volumeOfSKUsBenchMarkedSavingsVsShouldCost = scmData?.benchMarkSavingsHeaderDetails?.totalVolume
    const volumeOfSKUsNetSavingsTotalOpportunity = scmData?.netSavingsHeaderDetails?.totalVolume
    const matchsavingsOpportunityIdentified = volumeOfSKUssavingsOpportunityIdentified?.match(/^([\d.]+)([A-Za-z]+)$/);
    let volumeOfSKUssavingsOpportunityIdentifiedValue = matchsavingsOpportunityIdentified && matchsavingsOpportunityIdentified[1]
    let volumeOfSKUssavingsOpportunityIdentifiedUnit = matchsavingsOpportunityIdentified && matchsavingsOpportunityIdentified[2]

    const matchBenchMarkedSavingsVsShouldCost = volumeOfSKUsBenchMarkedSavingsVsShouldCost?.match(/^([\d.]+)([A-Za-z]+)$/);
    let volumeOfSKUsBenchMarkedSavingsVsShouldCostValue = matchBenchMarkedSavingsVsShouldCost && matchBenchMarkedSavingsVsShouldCost[1]
    let volumeOfSKUsBenchMarkedSavingsVsShouldCostUnit = matchBenchMarkedSavingsVsShouldCost && matchBenchMarkedSavingsVsShouldCost[2]

    const matchNetSavingsTotalOpportunity = volumeOfSKUsNetSavingsTotalOpportunity?.match(/^([\d.]+)([A-Za-z]+)$/);
    let volumeOfSKUsmatchNetSavingsTotalOpportunityValue = matchNetSavingsTotalOpportunity && matchNetSavingsTotalOpportunity[1]
    let volumeOfSKUsmatchNetSavingsTotalOpportunityUnit = matchNetSavingsTotalOpportunity && matchNetSavingsTotalOpportunity[2]
    // if(match){
    //      volumeOfSKUsValue = splitValueWithUnit(match[1])?.['numericValue']
    //      volumeOfSKUsUnit = splitValueWithUnit(match[2])?.['unit']
    // }
    // console.log('match', match)
    // console.log('totalPurchaseCost', totalPurchaseCost)

    const wtdAvgGapInDollarsSavingsOpportunityIdentified = scmData?.savingsOpportunityHeaderDetails?.weightedAverageGap
    const wtdAvgGapInDollarsSavingsOpportunityIdentifiedValue = splitValueWithUnit(wtdAvgGapInDollarsSavingsOpportunityIdentified)?.['numericValue']
    const wtdAvgGapInPercentSavingsOpportunityIdentified = scmData?.savingsOpportunityHeaderDetails?.weightedAverageGapPercent

    const wtdAvgGapInDollarsBenchMarkedSavingsVsShouldCost = scmData?.benchMarkSavingsHeaderDetails?.weightedAverageGap
    const wtdAvgGapInDollarsBenchMarkedSavingsVsShouldCostValue = splitValueWithUnit(wtdAvgGapInDollarsBenchMarkedSavingsVsShouldCost)?.['numericValue']
    const wtdAvgGapInPercentBenchMarkedSavingsVsShouldCost = scmData?.benchMarkSavingsHeaderDetails?.weightedAverageGapPercent

    const wtdAvgGapInDollarsNetSavingsTotalOpportunity = scmData?.netSavingsHeaderDetails?.weightedAverageGap
    const wtdAvgGapInDollarsNetSavingsTotalOpportunityValue = splitValueWithUnit(wtdAvgGapInDollarsNetSavingsTotalOpportunity)?.['numericValue']
    const wtdAvgGapInPercentNetSavingsTotalOpportunity = scmData?.netSavingsHeaderDetails?.weightedAverageGapPercent

    
    const donutChartByCategoryRef = useRef()
    const donutChartByBURef = useRef()
    const [catChartswitcherIndex, setCatChartSwitcherIndex] = useState(0)
    const [buChartswitcherIndex, setBuChartSwitcherIndex] = useState(0)

    const categoryChartData = scmData?.categoryDetails;
    const categorySavingsColor = categoryChartData?.color
    const catSavingsHeaderValue = categoryChartData?.saving?.total;
    const catSKUsHeaderValue = categoryChartData?.sku?.total;

    
    const processCategoryData = (categoryChartData, key, nameKey) => {
        const chartValues = categoryChartData?.[key]?.values;
      
        const transformedData = chartValues?.map((item) => ({
          category: item.sector,
          name: item?.[nameKey],
          color: item?.colorCode || "#000000",
          sectorColor: item.sectorColorCode || "#000000",
          value: Number(item.value),
        })) || [];
      
        const uniqueSectors = new Set(transformedData.map((item) => item.category));
        const hasMultipleSectors = uniqueSectors.size > 1;
      
        return {
          transformedData,
          hasMultipleSectors,
        };
    };
    const { 
        transformedData: transformedCatSavingsData, 
        hasMultipleSectors: multipleSectorFlagForCatSavingsChart 
    } = processCategoryData(categoryChartData, "saving", "category");
    
    const { 
        transformedData: transformedCatSKUsData, 
        hasMultipleSectors: multipleSectorFlagForCatSKUsChart 
    } = processCategoryData(categoryChartData, "sku", "category");


    const buChartData = scmData?.buDetails;
    const buSKUsHeaderValue = buChartData?.sku?.total;
    const buSavingsHeaderValue = buChartData?.saving?.total;
    const buSavingsColor = buChartData?.color

    const { 
        hasMultipleSectors: multipleSectorFlagForBUSavingsChart, 
        transformedData: transformedBUSavingsData 
    } = processCategoryData(buChartData, "saving", "bu");
    
    const { 
        hasMultipleSectors: multipleSectorFlagForBUSKUsChart, 
        transformedData: transformedBUSKUsData
    } = processCategoryData(buChartData, "sku", "bu");
    

    // const filteredPriceChartColors = priceChartColors.filter(item => priceChangeChartColors?.[item.key] !== null);
    const lineChartLegends= [
        {
            "name": "# Unique SKUs Modeled",
            "color": "#B05788" // "#33ABDA
        },
        // {
        //     "name": "# SKUs Re-modeled",
        //     "color": "#B05788"
        // },
        {
            "name": "Opportunities Identified ($)",
            "color": "#0078A7"
        }]
             
      
        const columnsToInclude = [
          "CATEGORY L2",
          "SECTOR-BU",
          "# UNIQUE SKUS MODELED",
          "VOLUME OF SKUS",
          "PURCHASE COST / UNIT VOL. ($)",
          "GAP ∆ / UNIT VOL. ($)",
          "GAP ∆ / UNIT VOL. (%)",
          "SHOULD COST / UNIT VOL. ($)",
          // "MATERIAL COST %",
          // "Conversion COST %",
          // "LOGISTICS COST %",
          // "OVERHEAD COST %",
          // "VALUE ADD COST %"
          "Material Cost %",
          "Conversion Cost %",
          "Overhead And Indirects Cost %",
          "Profit %",
          "LOGISTICS COST %"
          // "PROFIT%"
        ];
        
        const columnMapping = {
          category: "CATEGORY L2",
          sectorBU: "SECTOR-BU",
          newSKUs: "# UNIQUE SKUS MODELED",
          volume: "VOLUME OF SKUS",
          purchaseCost: "PURCHASE COST / UNIT VOL. ($)",
          gapValue: "GAP ∆ / UNIT VOL. ($)",
          gapPercent: "GAP ∆ / UNIT VOL. (%)",
          shouldCost: "SHOULD COST / UNIT VOL. ($)",
          // materialCost: "MATERIAL COST %",
          // indirectCost: "INDIRECT COST %",
          // logisticsCost: "LOGISTICS COST %",
          // overheadCost: "OVERHEAD COST %",
          // valueAddCost: "VALUE ADD COST %"
          materialCost: "Material Cost %",
          conversionCost: "Conversion Cost %",
          overheadAndIndirectCost: "Overhead And Indirects Cost %",
          profitPercent: "Profit %",
          logisticsCost: "LOGISTICS COST %"
          // "profitPercent": "PROFIT%"
        };

          useEffect(() => {
            setToggleValue(true); // explicitly reset
          }, [waterfallChartData]);

          useEffect(() => {
            setBarChartToggleValue(false); // explicitly reset
          }, [scmData?.monthWiseSkuCountDetails]);

          const scmModalRef = useRef();
          const scmBarChartRef = useRef();
          const scmLineBarChartRef = useRef();

          const { showToast } = useToast();


        
        const checkPDFDownloaded = () => {}

    
    return (
        <Modal
            closeOnOutsideClick={false}
            hideCloseButton={false}
            onCloseModal={handleClose}
            primaryButtonProps={{
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >            
            <div ref={scmModalRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        {userData.FirstName}, total gross savings opportunity identified is <b>{savingsOpportunityIdentified ? savingsOpportunityIdentified : 0}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>        
                    {
                        isLoading ? (
                            <></>
                        ) :                    
                        <>
                            {/* <ButtonGroup
                                style={{ marginRight: '2rem' }}
                                className="buy-con-button-group"
                                items={buttonGroupItems}
                                size="small"
                            /> */}
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <CustomButtons isModal={true} appList={scmData?.apps} />
                                {/* <button onClick={() => handleDomToImgDownloadPdf(scmModalRef, "SCM_Modal")}>PDF</button> */}
                                <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                    <DropdownWithIcons modalRef={scmModalRef} kpiName={"SCM_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                </span>
                            </span>
                        </>
                    }
                </div>
                                <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex" }}><Icon alt="" icon="info" size="small" /> &nbsp; {"Should Cost Modelling capability is available for 3 categories: CORRUGATED | PLASTIC BOTTLES/PRE-FORMS | CLOSURES "}</div>

                <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex" }}><Icon alt="" icon="info" size="small" /> &nbsp; {"Cans data validation on the SCM app is WIP"}</div>        
                {(scmData?.lastUpdate) && (scmData?.lastUpdate!=="-") && <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(scmData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(scmData?.refreshFrequency)}</div>}
                {/* <ModalFilters modalName={"Archlet"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getArchletDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} /> */}
                <ModalFilters modalName={"Should Cost Modelling"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getSCMDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} />
                <br />

                {/* <WorldMap/> */}
                {
                    (isLoading) ? // dataLoadActionType!=="SUCCESS_ARCHLET_DETAIL_VIEW_ACTION" || 
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                                <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%',display:'flex' }}>
                                    <div className='header-kpi-wrapper'>
                                    {
                                        savingsOpportunityIdentified  ?
                                            <>
                                                <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                                                    <div>
                                                        <div className= "spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value'>{formatNumberWithCommas(savingsOpportunityIdentifiedValue) || 0}</div>
                                                            <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{savingsOpportunityIdentifiedUnit} </div>
                                                        </div>
                                                        <div className='scm-kpi-card-text' style={{ display: "flex"}}>Gross Savings Opportunity Identified</div>
                                                        <div className='archlet-modal-header-kpi-description' style={{fontSize: '10px'}}>(where Purchase Cost &gt; Should Cost)</div>
                                                    </div>
                                                    <br/>
                                                    {/* <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                                        <div >
                                                            <span className='supplier-discovery-card-value' style={{fontSize: '16px', fontWeight: '700'}}>{formatNumberWithCommas(volumeOfSKUssavingsOpportunityIdentifiedValue) || 0}</span>
                                                            <span className='spend-modal-alpha-value' style={{fontWeight: '700', fontSize: '10px'}}>{volumeOfSKUssavingsOpportunityIdentifiedUnit} </span>
                                                            <div className='kpi-card-last-update'>Volume of SKUs</div>
                                                        </div>
                                                        

                                                        <div className="archlet-modal-divider-verticle" />

                                                        <div style={{width: '10rem'}}>
                                                            <span className='supplier-discovery-card-value' style={{fontSize: '16px', fontWeight: '700'}}>{wtdAvgGapInPercentSavingsOpportunityIdentified} / {wtdAvgGapInDollarsSavingsOpportunityIdentifiedValue}</span>
                                                            <div className='kpi-card-last-update'>Wtd. Avg. Gap ∆ /<br/>Unit Vol. (% / $)</div>
                                                        </div>

                                                        <div className="archlet-modal-divider-verticle" />

                                                        <div >
                                                            <span className='supplier-discovery-card-value' style={{fontSize: '16px', fontWeight: '700'}}>{totalShouldCostSavingsOpportunityIdentifiedValue}</span>
                                                            <span className='spend-modal-alpha-value' style={{fontWeight: '700', fontSize: '10px'}}>{totalShouldCostSavingsOpportunityIdentifiedUnit} </span>
                                                            <div className='kpi-card-last-update'>Total Should Cost</div>
                                                        </div>

                                                        <div className="archlet-modal-divider-verticle" />

                                                        <div >
                                                            <span className='supplier-discovery-card-value' style={{fontSize: '16px', fontWeight: '700'}}>{totalPurchaseCostValueSavingsOpportunityIdentified}</span>
                                                            <span className='spend-modal-alpha-value' style={{fontWeight: '700', fontSize: '10px'}}>{totalPurchaseCostUnitSavingsOpportunityIdentified} </span>
                                                            <div className='kpi-card-last-update'>Total Purchase Cost</div>
                                                        </div>
                                                    </div> */}
                                                </Col>
                                            </>
                                            : ''
                                    }
{/* 
                                    {
                                        benchMarkedSavingsVsShouldCost ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                    <div>
                                                        <div className= "spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value' style={{color: '#027C06'}}>{formatNumberWithCommas(benchMarkedSavingsVsShouldCostValue) || 0}</div>
                                                            <div className="spend-modal-alpha-value" style={{ display: "flex", color: '#027C06' }}>{benchMarkedSavingsVsShouldCostUnit} </div>

                                                            
                                                        </div>
                                                        
                                                        <div className='spend-modal-manage-spend'>Benchmarked Savings vs Should Cost</div>
                                                        <div className='archlet-modal-header-kpi-description' style={{fontSize: '10px'}}>(where Purchase Cost &lt;= Should Cost)</div>
                                                    </div>
                                                    <br/>
                                                    
                                                </Col>
                                            </>
                                         : ''
                                    } */}
                                    {
                                        // totalPurchaseCost  ?
                                           <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={4} lg={4} xl={4} style={{display: 'flex'}}>
                                                    <div>
                                                        <div className= "spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value'>{formatNumberWithCommas(NetSavingsTotalOpportunityValue) || 0}</div>
                                                            <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{NetSavingsTotalOpportunityUnit} </div>
                                                        </div>
                                                        <div className='scm-kpi-card-text' style={{ display: "flex" }}>Total Net Savings Opportunity</div>
                                                        <div className='archlet-modal-header-kpi-description' style={{fontSize: '10px'}}>(Total Purchase Cost - Total Should Cost)</div>
                                                    </div>
                                                    {/* <br/> */}
                                                    
                                                </Col>
                                                <Col xs={24} sm={24} md={4} lg={4} xl={4} style={{marginRight: '4rem'}}>
                                                    <div style={{width: '100%'}}>
                                                        <div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                                                            <div className='scm-kpi-card-text'>Total Should Cost</div>
                                                            {/* <div className='kpi-card-last-update'>Total Should Cost</div> */}
                                                            <div>
                                                                <span className='supplier-discovery-card-value' style={{fontSize: '16px', fontWeight: '700'}}>{totalShouldCostNetSavingsTotalOpportunityValue}</span>
                                                                <span className='spend-modal-alpha-value' style={{fontWeight: '700', fontSize: '10px'}}>{totalShouldCostNetSavingsTotalOpportunityUnit} </span>
                                                            </div>
                                                            
                                                            
                                                        </div>

                                                        {/* <div className="archlet-modal-divider-verticle" /> */}

                                                        <div >
                                                            <div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                                                                <div className='scm-kpi-card-text'>Total Purchase Cost</div>
                                                                <div>
                                                                    <span className='supplier-discovery-card-value' style={{fontSize: '16px', fontWeight: '700'}}>{totalPurchaseCostNetSavingsTotalOpportunityValue}</span>
                                                                    <span className='spend-modal-alpha-value' style={{fontWeight: '700', fontSize: '10px'}}>{totalPurchaseCostNetSavingsTotalOpportunityUnit} </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        

                                                        {/* <div className="archlet-modal-divider-verticle" /> */}

                                                        
                                                    </div>
                                                </Col>
                                                <Col xs={24} sm={24} md={7} lg={7} xl={7}>
                                                    <div style={{width: '100%'}}>
                                                        <div >
                                                            <div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                                                                <div className='scm-kpi-card-text' style={{position: 'relative', left: '1rem'}}>Volume of SKUs</div>
                                                                <div>
                                                                    <span className='supplier-discovery-card-value' style={{fontSize: '16px', fontWeight: '700'}}>{formatNumberWithCommas(volumeOfSKUsmatchNetSavingsTotalOpportunityValue) || 0}</span>
                                                                    <span className='spend-modal-alpha-value' style={{fontWeight: '700', fontSize: '10px'}}>{volumeOfSKUsmatchNetSavingsTotalOpportunityUnit} </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div>Gross Savings Opportunity Identified</div> */}

                                                        {/* <div className="archlet-modal-divider-verticle" /> */}

                                                        <div >
                                                            <div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                                                                <div className='scm-kpi-card-text' style={{position: 'relative', left: '1rem'}}>Wtd. Avg. Gap ∆ / Unit Vol. (% / $)</div>
                                                                <div>
                                                                    <span className='supplier-discovery-card-value' style={{fontSize: '16px', fontWeight: '700'}}>{wtdAvgGapInPercentNetSavingsTotalOpportunity} / {wtdAvgGapInDollarsNetSavingsTotalOpportunityValue}</span>
                                                                </div>
                                                            {/* <span className='spend-modal-alpha-value' style={{fontWeight: '700', fontSize: '10px'}}>{savingsOpportunityIdentifiedUnit} </span> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </>
                                            // : ''
                                    }
                                     {/* {
                                        totalShouldCost ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className= "spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value'>{formatNumberWithCommas(totalShouldCostValue) || 0}</div>
                                                            <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{totalShouldCostUnit} </div>
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Total Should Cost</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }
                                    {
                                        volumeOfSKUs ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                    <div className= "spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value'>{formatNumberWithCommas(volumeOfSKUsValue !== null ? volumeOfSKUsValue : volumeOfSKUs) || 0}</div>
                                                            <div className="spend-modal-alpha-value" style={{ display: "flex" }}>{volumeOfSKUsUnit!== null ? volumeOfSKUsUnit : ''} </div>
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Volume of SKUs</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }
                                    {
                                        wtdAvgGapInDollars ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className= "spend-modal-alphanumeric-value">
                                                            <div className='spend-modal-numeric-value' style={{color: wtdAvgGapInDollars !== "$0" ? headerColorFlag == 'maroon' ? '#AA001A' : '#006A42' : '#3a3a3a'}}>{formatNumberWithCommas(wtdAvgGapInDollarsValue) || 0}</div>
                                                            
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Wtd Avg Gap ∆<br/> / unit Vol. ( $ )</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    }

                                    {
                                        wtdAvgGapInPercent ?
                                            <>
                                                <div className="archlet-modal-divider-verticle" />
                                                <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                    <div>
                                                        <div className="archlet-modal-alphanumeric-value">
                                                            <div className="archlet-modal-header-kpi" style={{color: wtdAvgGapInPercent !== "0.0%" ? headerColorFlag == 'maroon' ? '#AA001A' : '#006A42' : '#3a3a3a'}}>{wtdAvgGapInPercent ? wtdAvgGapInPercent : 0}</div>
                                                            <div className="archlet-modal-header-unit"></div>
                                                        </div>
                                                        <div className='archlet-modal-header-kpi-description' style={{ display: "flex" }}>Wtd Avg Gap ∆<br/> / unit Vol. ( % )</div>
                                                    </div>
                                                </Col>
                                            </>
                                            : ''
                                    } */}
                                   
                                    </div>
                                </Card>
                                </Col> 
                                </Row>

                                
                            </div>

                            {/* Donut Charts */}
                            <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                                <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div ref={donutChartByCategoryRef}>
                                            <Card style={{ height: '100%', minHeight: '700px' }} className="archlet-chart-card"> 
                                                {
                                                        <>
                                                            <div className="archlet-chart-title" style={{ width: "100%", textAlign: "left", display: "flex", justifyContent:'space-between', minHeight:"58px" }}>
                                                                <span>
                                                                    {`${catChartswitcherIndex==0?"Gross Savings Opportunity Identified":"Total Unique SKUs Modeled"} - Split by Sector and Category L2`}
                                                                </span>
                                                                <span>
                                                                    <DropdownWithIcons modalRef={donutChartByCategoryRef} kpiName={`${catChartswitcherIndex==0?"Gross Savings Opportunity Identified":"Total Unique SKUs Modeled"} - Split by Sector and Category L2`} checkPDFDownloaded={checkPDFDownloaded}/>
                                                                </span>
                                                            </div>
                                                            <div style={{ width: '100%' }}>   
                                                                <Switcher
                                                                    className=""
                                                                    items={[
                                                                        {
                                                                        label: 'Gross Savings Opportunity Identified',
                                                                        leadingIcon: 'edit',
                                                                        showLeadingIcon: false,
                                                                        style: {width: '65%', display: 'flex', justifyContent: 'center'}
                                                                        },
                                                                        {
                                                                        label: 'Total Unique SKUs Modeled',
                                                                        leadingIcon: 'edit',
                                                                        showLeadingIcon: false,
                                                                        style: {width: '50%', display: 'flex', justifyContent: 'center'}
                                                                        }
                                                                    ]}
                                                                    selectedItemIndex={0}
                                                                    onUpdate= {(val) => setCatChartSwitcherIndex(val)}
                                                                    style={{ display: 'flex', justifyContent: 'flex-start', width: '80%' }}
                                                                />
                                                            </div>
                                                            <>
                                                                <Row style={{ width: '100%', height: 75 }}>
                                                                    <Col span={24}>
                                                                        <div className="spend-stats-text">{catChartswitcherIndex==0?"Gross Savings Opportunity Identified":"Total Unique SKUs Modeled"}</div>
                                                                    </Col>
                                                                    {
                                                                        catChartswitcherIndex==0 &&
                                                                        <Col span={24}>
                                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                                <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(splitValueWithUnit(catSavingsHeaderValue)['numericValue'])}</div>
                                                                                <div className="spend-stats-alpha" style={{ fontSize: '12px' }}>{splitValueWithUnit(catSavingsHeaderValue)['unit']}</div>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                    {
                                                                        catChartswitcherIndex==1 &&
                                                                        <Col span={24}>
                                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                                <div className="spend-stats-value" style={{ fontSize: '25px' }}>{formatNumberWithCommas(catSKUsHeaderValue)}</div>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                </Row>

                                                            </>
                                                            {
                                                                categorySavingsColor && categorySavingsColor.length>0 ?
                                                                <>
                                                                    {
                                                                        catChartswitcherIndex==0 && 
                                                                        <SpendDonutChart countryData={transformedCatSavingsData} flag={multipleSectorFlagForCatSavingsChart} isSpendChart={true}  />
                                                                    }
                                                                    {
                                                                        catChartswitcherIndex==1 && 
                                                                        <SpendDonutChart countryData={transformedCatSKUsData} flag={multipleSectorFlagForCatSKUsChart} />
                                                                    }
                                                                    <br/>
                                                                    <LegendList legends={categorySavingsColor} />
                                                                </> :
                                                                <NoData />
                                                            }
                                                        </> 
                                                }
                                            </Card>
                                        </div>
                                    </Col>

                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <div ref={donutChartByBURef}>
                                            <Card style={{ height: '100%', minHeight: '700px' }} className="archlet-chart-card"> 
                                                {
                                                        <>
                                                            <div className="archlet-chart-title" style={{ width: "100%", textAlign: "left", display: "flex", justifyContent:'space-between', minHeight:"58px" }}>
                                                                <span> 
                                                                    {`${buChartswitcherIndex==0?"Gross Savings Opportunity Identified":"Total Unique SKUs Modeled"} - Split by Sector and Business Unit/Market`}
                                                                </span>
                                                                <span>
                                                                    <DropdownWithIcons
                                                                     checkPDFDownloaded={checkPDFDownloaded}
                                                                     kpiName={`${buChartswitcherIndex==0?"Gross Savings Opportunity Identified":"Total Unique SKUs Modeled"} - Split by Sector and Business Unit/Market`}
                                                                     modalRef={donutChartByBURef} />
                                                                </span>
                                                            </div>
                                                            <div style={{ width: '100%' }}>   
                                                                <Switcher
                                                                    style={{ display: 'flex', justifyContent: 'flex-start', width: '80%' }}
                                                                    onUpdate= {(val) => setBuChartSwitcherIndex(val)}
                                                                    selectedItemIndex={0}
                                                                    className=""
                                                                    items={[
                                                                        {
                                                                            showLeadingIcon: false,
                                                                            leadingIcon: 'edit',
                                                                            label: 'Gross Savings Opportunity Identified',
                                                                            style: {width: '65%', display: 'flex', justifyContent: 'center'}
                                                                        },
                                                                        {
                                                                            leadingIcon: 'edit',
                                                                            showLeadingIcon: false,
                                                                            label: 'Total Unique SKUs Modeled',
                                                                            style: {width: '50%', display: 'flex', justifyContent: 'center'}
                                                                        }
                                                                    ]}
                                                                />
                                                            </div>
                                                            <>
                                                                <Row style={{ width: '100%', height: 75 }}>
                                                                    <Col span={24}>
                                                                        <div className="spend-stats-text">
                                                                            {buChartswitcherIndex==0?
                                                                                "Gross Savings Opportunity Identified":
                                                                                "Total Unique SKUs Modeled"
                                                                            }</div>
                                                                    </Col>
                                                                    {
                                                                        buChartswitcherIndex==0 &&
                                                                        <Col span={24}>
                                                                            <div 
                                                                                style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                                <div className="spend-stats-value"
                                                                                     style={{ fontSize: '25px' }}>
                                                                                        {formatNumberWithCommas(splitValueWithUnit(buSavingsHeaderValue)['numericValue'])}
                                                                                </div>
                                                                                <div className="spend-stats-alpha" 
                                                                                     style={{ fontSize: '12px' }}>
                                                                                        {splitValueWithUnit(buSavingsHeaderValue)['unit']}
                                                                                </div>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                    {
                                                                        buChartswitcherIndex==1 &&
                                                                        <Col span={24}>
                                                                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                                                                <div className="spend-stats-value" style={{ fontSize: '25px' }}>
                                                                                    {formatNumberWithCommas(buSKUsHeaderValue)}
                                                                                </div>
                                                                            </div>
                                                                        </Col>
                                                                    }
                                                                </Row>

                                                            </>
                                                            {
                                                            buSavingsColor && buSavingsColor.length>0 ?
                                                                <>
                                                                    {
                                                                        buChartswitcherIndex==0 && 
                                                                        <SpendDonutChart isSpendChart={true} 
                                                                            countryData={transformedBUSavingsData} 
                                                                            flag={multipleSectorFlagForBUSavingsChart} 
                                                                              />
                                                                    }
                                                                    {
                                                                        buChartswitcherIndex==1 && 
                                                                        <SpendDonutChart 
                                                                            flag={multipleSectorFlagForBUSKUsChart}
                                                                            countryData={transformedBUSKUsData}  />
                                                                    }
                                                                    <br/>
                                                                    <LegendList legends={buSavingsColor} />
                                                                </> :
                                                                <NoData />
                                                            }
                                                        </> 
                                                }
                                            </Card>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        
                            <div>

                            

                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>


                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={scmLineBarChartRef} style={{height: '100%'}}>
                                    <Card style={{ height: '100%' }} className="archlet-chart-card">
                                        <div className="archlet-chart-title" ># Unique SKUs Modeled vs $ Opportunity Identified
                                            {/* <button onClick={() => handleDomToImgDownloadPdf("scmLineBarChartRef")} style={{ marginTop: 10 }}>
                                                PDF
                                        </button> */}
                                            <span style={{float: 'right'}}>
                                                <DropdownWithIcons modalRef={scmLineBarChartRef} kpiName={"# Unique SKUs Modeled vs $ Opportunity Identified"} checkPDFDownloaded={checkPDFDownloaded}/>
                                            </span>

                                        </div>
                                        {
                                        (linebarchartsavingsOpportunityMonthWiseSkuCountData && linebarchartsavingsOpportunityMonthWiseSkuCountData?.length > 0) || (linebarchartNetSavingsMonthWiseSkuCountData && linebarchartNetSavingsMonthWiseSkuCountData?.length>0) ?
                                                <>
                                                    <div style={{display: 'flex', width: '100%'}}>
                                                        <div style={{color: barChartToggleValue ? '#616161' : '#3A3A3A', fontWeight : !barChartToggleValue ? 500 : '', marginRight: '10px' }}>
                                                        {/* <InfoIcon  text={"For Corrugates (PBNA): SGA Cost = Overhead; R&D = Indirect For Cans: Value Add Discrete + Process = Value Add Discrete For Preform and Bottle: Preassembly by Internal = Value Add Discrete"} /> */}
                                                        Gross Savings<br/>Opps. Identified
                                                        </div>
                                                        
                                                        <div>
                                                        <Toggle 
                                                            onUpdate={() => {
                                                                setBarChartToggleValue(!barChartToggleValue)
                                                            }
                                                            }
                                                            // size="small"
                                                            // value=""
                                                            // variant="horizontal"
                                                        />
                                                        </div>
                                                        <div  style={{marginLeft: '10px', color: !barChartToggleValue ? '#616161' : '#3A3A3A', fontWeight : barChartToggleValue ? 500 : ''}}>
                                                            Total Net<br/>Savings Opps.
                                                        </div>
                                                        <div style={{marginLeft: 'auto'}}>
                                                            <div  style={{fontSize: '15px', fontWeight: '700'}}>{!barChartToggleValue ? uniqueSkusModeledSavingsOpportunityCount : uniqueSkusModeledNetSavingsCount}</div>
                                                            <div className='archlet-modal-header-kpi-description'>Unique SKUs Modeled</div>
                                                        </div>
                                                    </div>
                                                    <SCMLineBarChart linebarchartData ={!barChartToggleValue ? linebarchartsavingsOpportunityMonthWiseSkuCountData : linebarchartNetSavingsMonthWiseSkuCountData}/>
                                                    {/* <LegendList legends={lineChartLegends} /> */}
                                                    {!barChartToggleValue && linebarchartsavingsOpportunityMonthWiseSkuCountData?.length > 0 ? 
                                                            <LegendList legends={lineChartLegends} /> : 
                                                     barChartToggleValue && linebarchartNetSavingsMonthWiseSkuCountData?.length > 0 ? 
                                                            <LegendList legends={lineChartLegends} /> : ''}
                                                </>      
                                            : <NoData />
                                        }
                                    </Card>
                                    </div>
                                </Col>   


                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={scmBarChartRef} style={{height: '100%'}}>
                                    <Card style={{ height: '100%' }} className="archlet-chart-card">
                                    {/* <div ref={scmBarChartRef}> */}
                                        <div className="archlet-chart-title" >
                                        
                                            Weighted Avg. Cost Breakdown of Should Cost vs Purchase Cost
                                            <InfoIcon  style={{position: 'relative', left: '0.5rem'}}
                                                    text={`For Corrugates (PBNA): SGA Cost = Overhead; R&D = Indirect
                                                    For Cans: Value Add Discrete + Process = Value Add Discrete
                                                    For Preform and Bottle: Preassembly by Internal = Value Add Discrete`} />
                                            {/* <button onClick={() => handleDomToImgDownloadPdf(scmBarChartRef, "Weighted Avg. Cost Breakdown of Should Cost vs Purchase Cost")} style={{ marginTop: 10 }}>
                                            PDF
                                            </button> */}
                                            <span style={{float: 'right'}}>
                                                <DropdownWithIcons modalRef={scmBarChartRef} kpiName={"Weighted Avg. Cost Breakdown of Should Cost vs Purchase Cost"} checkPDFDownloaded={checkPDFDownloaded}/>
                                            </span>
                                        </div>
                                        <div className='archlet-modal-header-kpi-description' style={{fontSize: '10px', width: '100%'}}>
                                            For Corrugates (PBNA): SGA Cost = Overhead; R&D = Indirect For Cans: Value Add Discrete + Process = Value Add Discrete<br/>For Preform and Bottle: Preassembly by Internal = Value Add Discrete
                                        </div>
                                        {
                                            !isAllDataZero?
                                            <>
                                                    <div style={{display: 'flex', width: '100%'}}>
                                                        <div style={{color: toggleValue ? '#616161' : '#3A3A3A', fontWeight : !toggleValue ? 500 : '', marginRight: '10px'}}>
                                                        {/* <InfoIcon  text={"For Corrugates (PBNA): SGA Cost = Overhead; R&D = Indirect For Cans: Value Add Discrete + Process = Value Add Discrete For Preform and Bottle: Preassembly by Internal = Value Add Discrete"} /> */}
                                                        Value in Numbers
                                                        </div>
                                                        
                                                            <div>
                                                        <Toggle 
                                                            onUpdate={() => {
                                                                setToggleValue(!toggleValue)
                                                            }
                                                            }
                                                            checked={toggleValue}
                                                            // size="small"
                                                            // value=""
                                                            // variant="horizontal"
                                                        />
                                                        </div>
                                                        <div  style={{marginLeft: '10px', color: !toggleValue ? '#616161' : '#3A3A3A', fontWeight : toggleValue ? 500 : ''}}>
                                                        Value in %
                                                        </div>
                                                    </div>
                                                    {/* {
                                                    waterfallChartData && waterfallChartData?.length > 0 ?
                                                            <> */}
                                                                <SCMWaterfallChart waterfallChartData ={waterfallChartData} toggleValue={toggleValue}/>
                                                            {/* </>      
                                                        : <NoData />
                                                    } */}
                                            </>
                                            : <NoData />
                                        }
                                    {/* </div> */}
                                    </Card>
                                    </div>
                                </Col>
                                
                                 
                            </Row>
                            <br />
                            <br />
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                {/* <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                                                                        Supplier Count by Sectors and Categories  &nbsp;<InfoIcon text={"The difference in # of suppliers (sector-wise) is because of same supplier being registered on multiple NAICS category"} />
                                                                </div> */}
                                    {
                                    scmTableData && scmTableData?.length > 0 ?
                                        <div className="ph-table-wrapper">
                                            <CommonTable 
                                                // className="scm-table" 
                                                className="scm-table-2" 
                                                data={scmTableData} columns={columns} 
                                                tableHeader="Weighted Avg. Comparison of Purchase Cost vs Should Cost" 
                                                enableSorting={true}
                                                columnsToInclude={columnsToInclude} columnMapping={columnMapping} tableName={'WEIGHTED AVG. COMPARISON OF PURCHASE COST VS SHOULD COST'} />
                                        </div>   
                                        : <Card style={{ height: '100%' }}><NoData /></Card>
                                    }
                                </Col>
                            </Row>
                            <br />
                            <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                                {
                                    scmData?.owners?.length > 0 &&
                                    <div style={{width: '100%'}}>Please reach out to {scmData?.owners?.map((contact, index) => (
                                        <React.Fragment key={index}>
                                            <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                            {index < scmData?.owners?.length - 1 && ', '}
                                        </React.Fragment>
                                    ))} for any query on the data displayed.</div>
                                }
                                <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                            </div>
                            
                            </div>
                            
                        </>
                }
                <br/>
            </div>
        </Modal>
    )
}

export default SCMModal